<template>
    <span :class="avatarClass" style="sizeStyle">
        <img v-if="isImageAvatar" :src="src" @error="handleError" :alt="alt" :srcset="srcSet" style="object-fit:fit" />
        <i v-else-if="icon" class="icon" />
        <slot v-else></slot>
    </span>
</template>

<script>
export default {
    name: 'IuAvatar',
    props: {
        size: {
            type: [Number, String],
            validator(val) {
                if (typeof val === 'string') {
                    return ['large', 'medium', 'small'].includes(val);
                }
                return typeof val === 'number';
            },
        },
        shape: {
            type: String,
            default: 'circle',
            validator(val) {
                return ['circle', 'square'].includes(val);
            },
        },
        icon: String,
        src: String,
        alt: String,
        srcSet: String,
        error: Function,
        fit: {
            type: String,
            default: 'cover',
        },
    },
    data() {
        return {
            isImageExist: true,
        };
    },
    computed: {
        avatarClass() {
            const { size, icon, shape } = this;
            let classList = ['iu-avatar'];
            if (size && typeof size === 'string') {
                classList.push(`iu-avatar--${size}`);
            }
            if (icon) {
                classList.push('iu-avatar--icon');
            }
            if (shape) {
                classList.push(`iu-avatar--${shape}`);
            }
            return classList.join(' ');
        },
        sizeStyle() {
            return typeof size === 'number'
                ? {
                      height: `${this.size}px`,
                      width: `${this.size}px`,
                      lineHeight: `${this.size}px`,
                  }
                : {};
        },
        isImageAvatar() {
            return this.isImageExist && this.src;
        },
    },
    methods: {
        handleError() {
            const { error } = this;
            const errorFlag = error ? error() : undefined;
            if (errorFlag !== false) {
                this.isImageExist = false;
            }
        },
    },
};
</script>

<style scoped>
.iu-avatar {
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    overflow: hidden;
    color: #fff;
    background: #c0c4cc;
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
}
.iu-avatar > img {
    display: block;
    height: 100%;
    vertical-align: middle;
}
.iu-avatar--circle {
    border-radius: 50%;
}
.iu-avatar--square {
    border-radius: 4px;
}
.iu-avatar--icon {
    font-size: 18px;
}
.iu-avatar--large {
    width: 40px;
    height: 40px;
    line-height: 40px;
}
.iu-avatar--medium {
    width: 36px;
    height: 36px;
    line-height: 36px;
}
.iu-avatar--small {
    width: 28px;
    height: 28px;
    line-height: 28px;
}
</style>
